import React, { useState, useEffect, useCallback } from 'react';
import { supabase } from '../supabaseClient';
import { useAuth } from '../contexts/AuthContext';
import './HistoricoPage.css';

const ICONE_ACAO = {
  'conta_criada': '📋',
  'conta_editada': '✏️',
  'conta_excluida': '🗑️',
  'tipo_criado': '🗂',
  'tipo_editado': '✏️',
  'tipo_excluido': '🗑️',
  'valor_alterado': '💰',
  'limite_alterado': '🎯',
  'usuario_criado': '👤',
};

function timeAgo(dateStr) {
  const diff = (Date.now() - new Date(dateStr)) / 1000;
  if (diff < 60) return 'agora mesmo';
  if (diff < 3600) return `${Math.floor(diff / 60)} min atrás`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h atrás`;
  if (diff < 604800) return `${Math.floor(diff / 86400)}d atrás`;
  return new Date(dateStr).toLocaleDateString('pt-BR');
}

export default function HistoricoPage() {
  const { profile } = useAuth();
  const [atividades, setAtividades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState('todos');

  const loadHistorico = useCallback(async () => {
    setLoading(true);
    const { data } = await supabase
      .from('historico_atividades')
      .select('*')
      .order('created_at', { ascending: false })
      .limit(100);
    setAtividades(data || []);
    setLoading(false);
  }, []);

  useEffect(() => { loadHistorico(); }, [loadHistorico]);

  const categorias = [
    { value: 'todos', label: 'Todos' },
    { value: 'valor_alterado', label: '💰 Valores' },
    { value: 'conta_criada', label: '📋 Contas' },
    { value: 'tipo_criado', label: '🗂 Tipos' },
    { value: 'limite_alterado', label: '🎯 Limites' },
  ];

  const filtradas = filtro === 'todos'
    ? atividades
    : atividades.filter(a => {
        if (filtro === 'conta_criada') return a.acao.startsWith('conta_');
        if (filtro === 'tipo_criado') return a.acao.startsWith('tipo_');
        return a.acao === filtro;
      });

  return (
    <div className="historico-page fade-in">
      <div className="historico-header">
        <div>
          <h2 className="historico-title">Registro de Atividades</h2>
          <p className="text-muted text-sm">Acompanhe as alterações recentes no sistema</p>
        </div>
        <button className="btn btn-ghost btn-sm" onClick={loadHistorico}>↻ Atualizar</button>
      </div>

      <div className="historico-filtros">
        {categorias.map(c => (
          <button
            key={c.value}
            className={`btn btn-sm ${filtro === c.value ? 'btn-primary' : 'btn-ghost'}`}
            onClick={() => setFiltro(c.value)}
          >
            {c.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div style={{ display:'flex', justifyContent:'center', padding:'60px 0', gap:12, color:'var(--text2)' }}>
          <div className="spinner" style={{ width:28, height:28 }} />
          <span>Carregando...</span>
        </div>
      ) : filtradas.length === 0 ? (
        <div className="historico-empty">
          <p>Nenhuma atividade registrada ainda.</p>
          <p className="text-muted text-sm">As alterações aparecerão aqui conforme forem feitas.</p>
        </div>
      ) : (
        <div className="historico-lista">
          {filtradas.map(a => (
            <div key={a.id} className="historico-item">
              <div className="historico-icone">{ICONE_ACAO[a.acao] || '📝'}</div>
              <div className="historico-content">
                <div className="historico-desc">{a.descricao}</div>
                <div className="historico-meta">
                  <span className="historico-usuario">👤 {a.usuario_nome}</span>
                  <span className="historico-tempo">{timeAgo(a.created_at)}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
